__turbopack_context__.v({
  "className": "figtree_857760f3-module__jREI6G__className",
});
